export const normalizeSearchValue = (value) => {
  if (!value) return '';
  return String(value).toLowerCase().trim();
};

export const normalizeIdValue = (value) => {
  if (value === null || value === undefined) return '';
  return String(value);
};

export const levenshteinDistance = (left, right) => {
  if (left === right) return 0;
  if (!left) return right.length;
  if (!right) return left.length;

  const leftLength = left.length;
  const rightLength = right.length;
  const prev = new Array(rightLength + 1).fill(0);
  const curr = new Array(rightLength + 1).fill(0);

  for (let j = 0; j <= rightLength; j += 1) {
    prev[j] = j;
  }

  for (let i = 1; i <= leftLength; i += 1) {
    curr[0] = i;
    const leftChar = left.charCodeAt(i - 1);
    for (let j = 1; j <= rightLength; j += 1) {
      const cost = leftChar === right.charCodeAt(j - 1) ? 0 : 1;
      curr[j] = Math.min(
        prev[j] + 1,
        curr[j - 1] + 1,
        prev[j - 1] + cost
      );
    }
    for (let j = 0; j <= rightLength; j += 1) {
      prev[j] = curr[j];
    }
  }

  return prev[rightLength];
};

export const getMinLevenshteinDistance = (candidate, query) => {
  const normalizedCandidate = normalizeSearchValue(candidate);
  const normalizedQuery = normalizeSearchValue(query);
  if (!normalizedCandidate || !normalizedQuery) return Number.POSITIVE_INFINITY;

  if (normalizedCandidate.length <= normalizedQuery.length) {
    return levenshteinDistance(normalizedCandidate, normalizedQuery);
  }

  const windowSize = normalizedQuery.length;
  let minDistance = Number.POSITIVE_INFINITY;
  for (let i = 0; i <= normalizedCandidate.length - windowSize; i += 1) {
    const slice = normalizedCandidate.slice(i, i + windowSize);
    const distance = levenshteinDistance(slice, normalizedQuery);
    if (distance < minDistance) minDistance = distance;
    if (minDistance === 0) break;
  }
  return minDistance;
};

export const formatMessagesRemaining = (value, fallback = 0) => {
  if (value === undefined || value === null) return fallback;
  const numeric = Number(value);
  if (!Number.isFinite(numeric)) return fallback;
  return numeric > 200000 ? 'illimité' : numeric;
};
